import {
  AspectRatio,
  Box,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SystemProps,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import _ from 'lodash'

import WhatsAnItListButton, {
  WhatAnItListButtonVariant,
} from 'src/components/widgets/buttons/WhatsAnItListButton/WhatsAnItListButton'
import Loader from 'src/components/widgets/Loader/Loader'
import VimeoPlayer from 'src/components/widgets/VimeoPlayer/VimeoPlayer'
import { VIMEO_URL } from 'src/lib/constants'
import { BrandColor } from 'src/types'

const Explain: React.FC<
  { brandColor: BrandColor; variant: WhatAnItListButtonVariant } & SystemProps
> = ({ brandColor, variant, ...props }) => {
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(true)

  const isMobile = useBreakpointValue({ sm: true, md: false })
  if (isMobile === undefined) return null

  return (
    <Box {...props}>
      <WhatsAnItListButton
        variant={variant}
        brandColor={brandColor}
        onClick={() => {
          setOpen(true)
        }}
      />
      <Modal
        isOpen={open}
        isCentered
        onClose={() => setOpen(false)}
        size={isMobile ? 'full' : undefined}
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={isMobile ? 0 : 24}
          height={641}
          w={isMobile ? 'full' : 375}
          overflow="hidden"
        >
          <ModalHeader
            display="flex"
            justifyContent="center"
            px={0}
            border="1px solid"
            borderColor="vapor"
          >
            <ModalCloseButton left={4} top="18px" variant="boxModal" />
            <Text margin="auto" my={1}>
              What&rsquo;s an ItList?
            </Text>
          </ModalHeader>
          <ModalBody p={0}>
            {loading && (
              <Center w="100%" h="100%" position="absolute">
                <Loader />
              </Center>
            )}

            <AspectRatio ratio={9 / 13.8}>
              <VimeoPlayer
                url={VIMEO_URL}
                onReady={() => setLoading(false)}
                brandColor={brandColor}
              />
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}

export default Explain
